export enum CurrencyStoreEnum {
    DEFAULT = 'Main_Store',
    JP = 'Asia_JP',
    EURTIER1 = 'EUR_Tier1',
    SWEDEN = 'SWEDEN',
    UK = 'UK',
    AUS = 'AUS',
}
